export default "__VITE_ASSET__B$u5pUua__"